import '../assets/NcInputField.css';
import { defineComponent, useModel, useAttrs, useTemplateRef, computed, warn, openBlock, createElementBlock, normalizeClass, unref, createElementVNode, mergeProps, toDisplayString, createCommentVNode, withDirectives, renderSlot, vShow, createBlock, withCtx, createTextVNode, mergeModels } from "vue";
import { d as mdiCheck, j as mdiAlertCircleOutline } from "./mdi.mjs";
import { N as NcButton } from "./NcButton.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper.mjs";
import { c as createElementId } from "./createElementId.mjs";
import { a as isLegacy } from "./legacy.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _hoisted_1 = { class: "input-field__main-wrapper" };
const _hoisted_2 = ["id", "aria-describedby", "disabled", "placeholder", "type", "value"];
const _hoisted_3 = ["for"];
const _hoisted_4 = { class: "input-field__icon input-field__icon--leading" };
const _hoisted_5 = {
  key: 2,
  class: "input-field__icon input-field__icon--trailing"
};
const _hoisted_6 = ["id"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: "NcInputField",
  props: /* @__PURE__ */ mergeModels({
    class: { default: "" },
    inputClass: { default: "" },
    id: { default: () => createElementId() },
    label: { default: void 0 },
    labelOutside: { type: Boolean },
    type: { default: "text" },
    placeholder: { default: void 0 },
    showTrailingButton: { type: Boolean },
    trailingButtonLabel: { default: void 0 },
    success: { type: Boolean },
    error: { type: Boolean },
    helperText: { default: "" },
    disabled: { type: Boolean },
    pill: { type: Boolean }
  }, {
    "modelValue": { required: true },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["trailingButtonClick"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const modelValue = useModel(__props, "modelValue");
    const props = __props;
    const emit = __emit;
    __expose({
      focus,
      select
    });
    const attrs = useAttrs();
    const inputElement = useTemplateRef("input");
    const hasTrailingIcon = computed(() => props.showTrailingButton || props.success);
    const internalPlaceholder = computed(() => {
      if (props.placeholder) {
        return props.placeholder;
      }
      if (props.label) {
        return isLegacy ? props.label : "";
      }
      return void 0;
    });
    const isValidLabel = computed(() => {
      const isValidLabel2 = props.label || props.labelOutside;
      if (!isValidLabel2) {
        warn("You need to add a label to the NcInputField component. Either use the prop label or use an external one, as per the example in the documentation.");
      }
      return isValidLabel2;
    });
    const ariaDescribedby = computed(() => {
      const ariaDescribedby2 = [];
      if (props.helperText) {
        ariaDescribedby2.push(`${props.id}-helper-text`);
      }
      if (attrs["aria-describedby"]) {
        ariaDescribedby2.push(String(attrs["aria-describedby"]));
      }
      return ariaDescribedby2.join(" ") || void 0;
    });
    function focus(options) {
      inputElement.value.focus(options);
    }
    function select() {
      inputElement.value.select();
    }
    function handleInput(event) {
      const target = event.target;
      modelValue.value = props.type === "number" && typeof modelValue.value === "number" ? parseFloat(target.value) : target.value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["input-field", [{
          "input-field--disabled": __props.disabled,
          "input-field--error": __props.error,
          "input-field--label-outside": __props.labelOutside || !isValidLabel.value,
          "input-field--leading-icon": !!_ctx.$slots.icon,
          "input-field--trailing-icon": hasTrailingIcon.value,
          "input-field--pill": __props.pill,
          "input-field--success": __props.success,
          "input-field--legacy": unref(isLegacy)
        }, _ctx.$props.class]])
      }, [
        createElementVNode("div", _hoisted_1, [
          createElementVNode("input", mergeProps(_ctx.$attrs, {
            id: __props.id,
            ref: "input",
            "aria-describedby": ariaDescribedby.value,
            "aria-live": "polite",
            class: ["input-field__input", __props.inputClass],
            disabled: __props.disabled,
            placeholder: internalPlaceholder.value,
            type: __props.type,
            value: modelValue.value.toString(),
            onInput: handleInput
          }), null, 16, _hoisted_2),
          !__props.labelOutside && isValidLabel.value ? (openBlock(), createElementBlock("label", {
            key: 0,
            class: "input-field__label",
            for: __props.id
          }, toDisplayString(__props.label), 9, _hoisted_3)) : createCommentVNode("", true),
          withDirectives(createElementVNode("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "icon", {}, void 0, true)
          ], 512), [
            [vShow, !!_ctx.$slots.icon]
          ]),
          __props.showTrailingButton ? (openBlock(), createBlock(NcButton, {
            key: 1,
            class: "input-field__trailing-button",
            "aria-label": __props.trailingButtonLabel,
            disabled: __props.disabled,
            variant: "tertiary-no-background",
            onClick: _cache[0] || (_cache[0] = ($event) => emit("trailingButtonClick", $event))
          }, {
            icon: withCtx(() => [
              renderSlot(_ctx.$slots, "trailing-button-icon", {}, void 0, true)
            ]),
            _: 3
          }, 8, ["aria-label", "disabled"])) : __props.success || __props.error ? (openBlock(), createElementBlock("div", _hoisted_5, [
            __props.success ? (openBlock(), createBlock(NcIconSvgWrapper, {
              key: 0,
              path: unref(mdiCheck)
            }, null, 8, ["path"])) : (openBlock(), createBlock(NcIconSvgWrapper, {
              key: 1,
              path: unref(mdiAlertCircleOutline)
            }, null, 8, ["path"]))
          ])) : createCommentVNode("", true)
        ]),
        __props.helperText ? (openBlock(), createElementBlock("p", {
          key: 0,
          id: `${__props.id}-helper-text`,
          class: "input-field__helper-text-message"
        }, [
          __props.success ? (openBlock(), createBlock(NcIconSvgWrapper, {
            key: 0,
            class: "input-field__helper-text-message__icon",
            path: unref(mdiCheck),
            inline: ""
          }, null, 8, ["path"])) : __props.error ? (openBlock(), createBlock(NcIconSvgWrapper, {
            key: 1,
            class: "input-field__helper-text-message__icon",
            path: unref(mdiAlertCircleOutline),
            inline: ""
          }, null, 8, ["path"])) : createCommentVNode("", true),
          createTextVNode(" " + toDisplayString(__props.helperText), 1)
        ], 8, _hoisted_6)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const NcInputField = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-feb04bef"]]);
export {
  NcInputField as N
};
//# sourceMappingURL=NcInputField.mjs.map
